export default __webpack_public_path__ + "static/media/meliImg_1.053134e7.png";